module.exports = __webpack_public_path__ + "img/mars-stroke.d65628dc.svg";